import {Component, HostListener, OnInit} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {Router} from '@angular/router';

@Component({
    selector: 'app-aarni-school-of-technology',
    templateUrl: './aarni-school-of-technology.component.html',
    styleUrls: ['./aarni-school-of-technology.component.scss']
})
export class AarniSchoolOfTechnologyComponent implements OnInit {
    testimonialSlideIndex: number = 0;
    testimonialSlidesCount: number = 3;

    testimonials = [
        {
            name: 'Abhishek Bhatia',
            course: 'B. Tech Civil',
            company: 'Jal Shakti Vibhag',
            image: 'assets/img/alumni-connect/alumni/alumni19.webp',
            feedback: `I am very grateful to ARNI University for shaping my career and helping me achieve my dream of becoming a civil engineer. The university’s practical learning approach, expert faculty, and well-equipped labs played a crucial role in building my technical expertise. On-site training and project work enhanced my knowledge base.`,
        },
        {
            name: 'Waseem Akram',
            course: 'M. Tech Civil',
            company: 'Shree Cement Ltd.',
            image: 'assets/img/alumni-connect/alumni/alumni20.webp',
            feedback: `I am very grateful to ARNI University – both the faculty and administrative departments. In my 2-year learning journey, I have never faced an issue regarding any studies, accommodations, or administrative work. They were superfast and efficient in their work and responsibilities. I had a great time over there.`,
        },
        {
            name: 'Pradeep Singh',
            course: 'B. Tech Mechanical',
            company: 'IIT Jammu',
            image: 'assets/img/alumni-connect/alumni/alumni18.webp',
            feedback: `The student support cell and placement cell are truly working hard for the comfort and success of the students. Due to their priceless efforts and constant guidance, I was able to bag a job in one of the most reputable organizations. They kept me updated about the placement drives and provided valuable tips and insights to help me grab the opportunity.`,
        },
        {
            name: 'Barun Sharma',
            course: 'B. Tech Mechanical',
            company: 'Public Works Department Jammu',
            image: 'assets/img/alumni-connect/alumni/alumni6.webp',
            feedback: `ARNI University is not just like another educational institute that only provides degrees. They are enlightened path of students with their highly professional teachers and admins for last long impact in personal & professional lives. I have gained exceptional skills that helps me to accomplish my career goals. `,
        },
        {
            name: 'Harshal Singh Thakur',
            course: 'B. Tech CSE',
            company: 'Genpact Bengaluru',
            image: 'assets/img/home-page-testimonials/harshal-singh.webp',
            feedback: `Apart from the studies and their positive behavior towards students, the one thing I loved about this university is its placement services. They have collaborated with big companies, which helps students to get real-world experience and internships with minimum effort.`,
        },
        {
            name: 'Nalin Dhiman',
            course: 'MCA',
            company: 'Stellar Innovations Pvt. Ltd.',
            image: 'assets/img/alumni-connect/alumni/alumni1.webp',
            feedback: `ARNI University is such a great place to learn. I have completed my MCA from this university, which has helped me to accomplish my career goals. They have fully furnished and well-maintained labs and allow easy access to the students. Faculty and administrations are supportive and student-oriented.`,
        }
    ];
    groupedTestimonials: any[][] = [];
    events = [
        {
            image: 'assets/img/home-page-events/event-home-page.jpg',
            date: '20 June 2024',
            title: 'Our Respected Chancellor met with Mr. Sudhir Chaudhary (Journalist at DD News)',
            description: 'To exchange insightful ideas and perspectives, our honorable Chancellor had the privilege to meet Mr. Sudhir Chaudhary, esteemed journalist at DD News.'
        },
        {
            date: '15 Sept 2023',
            title: 'Technovate 2024: Advanced Workshop on AI, Robotics, and Machine Learning at ARNI University',
            description: 'ARNI School of Technology organized Technovate 2024, a dynamic workshop on AI, Robotics, and Machine Learning for the 2024–25 session. Through hands-on projects and expert sessions, students were empowered to drive future innovation and technological excellence.',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/events/tech-event3.webp'
        },
        {
            date: '15 Sept 2023',
            title: 'Honoring Bharat Ratna M. Visvesvaraya on Engineers\' Day: A Legacy of Excellence',
            description: 'A heartfelt tribute was extended to Bharat Ratna M. Visvesvaraya during the Engineers\' Day celebration, commemorating his extraordinary legacy, visionary contributions, and enduring impact on the field of engineering.',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/events/tech-event2.webp'
        },
    ];

    announcements = [
        {
            date: '05 Nov 2024',
            text: 'Appointment of Dr. Rajneesh Kumar Singh as HOD of Computer Science & Application',
            color: 'bg-green-500'
        },
        {
            date: '05 Nov 2024',
            text: 'Appointment of Dr. Sudeep Varshney as HOD of Computer Science & Engineering',
            color: 'bg-yellow-500'
        },
        {
            date: '22 Aug 2024',
            text: 'Appointment of Prof. (Dr.) Ganesh Gupta as Professor-in-charge of the department',
            color: 'bg-pink-500'
        }
    ];
    /*departments = [
        { name: 'Computer Science', icon: 'fa-laptop-code' },
        { name: 'Electrical Engineering', icon: 'fa-bolt' },
        { name: 'Mechanical Engineering', icon: 'fa-cogs' },
        { name: 'Civil Engineering', icon: 'fa-building' },
        { name: 'Chemical Engineering', icon: 'fa-flask' }
    ];*/

    departments = [
        {
            name: 'Computer Science',
            icon: 'fa-laptop-code',
            branches: [
                'B.Tech CSE',
                'M.Tech CSE',
                'Ph.D CSE',
                'Ph.D Computer Application',
                'BCA',
                'MCA',
                'Integrated Program-BCA & MCA',
                'Diploma in Artifical Intelligence and Machine Learning',
                'Diploma in Forensic Science & Cyber Security',
            ]
        },
        {
            name: 'Electrical Engineering',
            icon: 'fa-bolt',
            branches: [
                'B.Tech EE',
                'B.Tech EEE',
                'M.Tech EEE',
                 'M.Tech EE',
                'Diploma EE',
            ]
        },
        {
            name: 'Mechanical Engineering',
            icon: 'fa-cogs',
            branches: [
                'B.Tech Mech',
                'M.Tech Mech',
                'Ph.D Mechanical Engg.',
            ]
        },
        {
            name: 'Civil Engineering',
            icon: 'fa-building',
            branches: [
                'B.Tech Civil',
                'M.Tech Civil',
                'Ph.D Civil',
            ]
        },
        {
            name: 'Electronics & Communication',
            icon: 'fa-satellite-dish',
            branches: [
                'B.Tech ECE',
                'M.tech ECE'
            ]
        },
        /*   {
               name: 'Multimedia & Animation',
               icon: 'fa-paint-brush',
               branches: [
                   'B.Sc. Multimedia and Animation'
               ]
           }*/
    ];

    faculties = [
        {
            name: 'Dr. Gurvinder Singh',
            designation: 'Dean CSA, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/dr-gurvinder-singh-dean-csa.webp',
        },
        {
            name: 'Dr. Sunita',
            designation: 'Assistant Professor, CSA, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/dr-sunita-assistant-professor-csa.webp',
        },
        {
            name: 'Mr. Vinay',
            designation: 'Assistant Professor, CSA, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/mr-vinay-assistant-professor-csa.webp',
        },
        {
            name: 'Ms. Jaspreet Kaur',
            designation: 'Teaching Assistant, CSA, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/ms-jaspreet-kaur-assistant-professor-csa.webp',
        },
        {
            name: 'Ms. Minakshi Thakur',
            designation: 'Assistant Professor, CSA, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/ms-minakshi-thakur-assistant-professor-csa.webp',
        },
        {
            name: 'Ms. Neha Rani',
            designation: 'Assistant Professor, CSE, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/ms-neha-rani-assistant-professor-cse.webp',
        },
        {
            name: 'Ms. Nitika',
            designation: 'Assistant Professor, CSA, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/ms-nitika-assistant-professor-csa.webp',
        },
        {
            name: 'Deepika',
            designation: 'Assistant Professor, CSA, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/ms-deepika-assistant-professor.webp',
        },
        {
            name: 'Mr. Rahul Kumar',
            designation: 'Assistant Professor, CSA, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/mr-rahul-kumar-assistant-professor-csa.png',
        },
        {
            name: 'Mr. Rishav',
            designation: 'Assistant Professor, CSA, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/rishav-assistant-professor-csa.png',
        },
        {
            name: 'Harjit Singh',
            designation: 'Assistant Professor, Electrical Engineering, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/harjit-singh-assistant-professor-electrical-engineering.png',
        },
        {
            name: 'Mr. Dalvir Singh',
            designation: 'Assistant Professor, Civil Engineering, Arni School of Technology',
            image: 'assets/img/assistant-professor/mr-dalvir-singh-arni-school-of-technology-civil-engineering.png',
        },
        {
            name: 'Surjit Singh',
            designation: 'Assistant Professor, Mechanical Engineering, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/surjit-singh-assistant-professor-mechanical-engineering.png',
        },
        {
            name: 'Rohit Kumar',
            designation: 'Assistant Professor, Civil Engineering, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/rohit-kumar-civil-engineering-assistant-professor.png',
        },
        {
            name: 'Naresh Kumar',
            designation: 'Assistant Professor, Electrical Engineering, Arni School of Technology',
            image: 'assets/img/school-wise-faculties/arni-school-of-technology/naresh-kumar-assistant-professor-ee.png',
        },
        {
            name: 'Mr. Ashish Kumar',
            designation: 'Academic Associate , (Mechanical Engineering) Arni School of Technology',
            image: 'assets/img/academic-associate/ashish-kumar-arni-school-of-technology-mechanical-engineering.png',
        },
    ];
    index = 0;
    recruiters = [
        {name: 'Adani Wilmar', logo: 'assets/img/companies/adani_wilmar.png'},
        {name: 'Amar Ujala', logo: 'assets/img/companies/amarujala.png'},
        {name: 'Amazon', logo: 'assets/img/companies/Amazon.png'},
        {name: 'CMC', logo: 'assets/img/companies/cmc-logo_0.png'},
        {name: 'Dish TV', logo: 'assets/img/companies/Dish_TV_2.png'},
        {name: 'Future Group', logo: 'assets/img/companies/FutureGroup.png'},
        {name: 'HCL', logo: 'assets/img/companies/hcl.png'},
        {name: 'ICICI', logo: 'assets/img/companies/icici_securities.png'},
        {name: 'Sleepwell', logo: 'assets/img/companies/sleepwell.png'},
        {name: 'SYNTEL', logo: 'assets/img/companies/syntel2.png'},
        {
            name: 'Tech Mahindra',
            logo: 'assets/img/companies/Tech_Mahindra_New_Logo1.png',
        },
        {name: 'Vodafone', logo: 'assets/img/companies/Vodafone_logo.png'},
        {name: 'Zee TV', logo: 'assets/img/companies/Zee_TV_2011.png'},
        {name: 'Genpact', logo: 'assets/img/companies/zenpact.png'},
        {name: 'Reliance', logo: 'assets/img/companies/amarujala.png'},
    ];

    nextSlide() {
        if (this.index < this.recruiters.length - 3) {
            this.index++;
        }
    }

    prevSlide() {
        if (this.index > 0) {
            this.index--;
        }
    }

    currentIndex = 0;
    translateX = 0;

    constructor(
        private meta: Meta,
        private titles: Title,
        private router: Router
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.updateMetaTags();
        this.scrollToContent();
        this.groupTestimonials();
    }

    @HostListener('window:resize')
    onResize() {
        this.groupTestimonials();
    }

    groupTestimonials(): void {
        const screenWidth = window.innerWidth;
        let perSlide = 1;
        if (screenWidth >= 1024) {
            perSlide = 3;
        } else if (screenWidth >= 768) {
            perSlide = 2;
        } else {
            perSlide = 1;
        }
        const grouped = [];
        for (let i = 0; i < this.testimonials.length; i += perSlide) {
            grouped.push(this.testimonials.slice(i, i + perSlide));
        }
        this.groupedTestimonials = grouped;
        if (this.testimonialSlideIndex >= this.groupedTestimonials.length) {
            this.testimonialSlideIndex = 0;
        }
    }

    scrollToContent() {
        const tabs = document.querySelectorAll('.tab-link');
        const tabContainer = document.querySelector('.tab-buttons');
        const header = document.querySelector('header');

        const tabHeight = tabContainer?.getBoundingClientRect().height || 0;
        const headerHeight = header?.getBoundingClientRect().height || 0;

        const totalOffset = tabHeight + headerHeight + 15;

        tabs.forEach(tab => {
            tab.addEventListener('click', (event: Event) => {
                event.preventDefault();

                tabs.forEach(t => t.classList.remove('active-tab'));
                (event.target as HTMLElement).classList.add('active-tab');

                const targetId = (event.target as HTMLElement).getAttribute('href')?.substring(1);
                if (targetId) {
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        const y = targetElement.getBoundingClientRect().top + window.pageYOffset - totalOffset;
                        window.scrollTo({top: y, behavior: 'smooth'});
                    }
                }
            });
        });
    }


    prev() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            this.translateX = -this.currentIndex * 25; // Move 25% left
        }
    }

    next() {
        if (this.currentIndex < this.faculties.length - 1) {
            this.currentIndex++;
            this.translateX = -this.currentIndex * 25; // Move 25% right
        }
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

    setTestimonialSlide(index: number) {
        this.testimonialSlideIndex = index;
    }

    updateMetaTags() {
        this.titles.setTitle('Undergraduate Courses for Science Students at ARNI School');
        this.meta.updateTag({
            name: 'description',
            content: `Explore undergraduate courses for science students at ARNI School of Technology. Prepare for a successful career with a top-tier education and hands-on experience.`
        });
    }

}
